export const TEST_ID = 'closeIcon';
